import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Login = loadable(() => pMinDelay(import('./Login'), 300), {
  fallback: <Loading />
});

const AsyncLogin = props => {

  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Login { ...props }/>
    </ApplicationLayout>
  );
};

AsyncLogin.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLogin;
